import React  from "react";
import {
  DropdownMenuCheckboxItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from "../ui/dropdown-menu";
import { Moon, Sun, SunMoon } from "lucide-react";
import useDarkMode from "@/hooks/useDarkMode";

export default function ThemeToggle() {
  const {currentTheme, setTheme}  = useDarkMode();
// const [currentTheme, setCurrentTheme] = useState(() => {
//   const colorThemeStr = localStorage.getItem("colorTheme");
//   return colorThemeStr ? JSON.parse(colorThemeStr) : "yellow";
// });

// // Apply theme whenever it changes
// useEffect(() => {
//   const themes = ["yellow", "dark"];

//   document.documentElement.classList.remove(...themes);
//   document.documentElement.classList.add(currentTheme);

//   localStorage.setItem("colorTheme", JSON.stringify(currentTheme));
// }, [currentTheme]);

// const setTheme = (selectedTheme) => {
//   if (currentTheme === selectedTheme) return;
//   setCurrentTheme(selectedTheme);
// };

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger
        className={` px-4 py-4 flex gap-4 items-center cursor-pointer text-[1.6rem] text-sidebar-foreground  leading-[2rem] text-left`}
      >
        <SunMoon
          className="text-foreground"
          style={{
            width: 16,
            height: 16,
          }}
        />
        Appearance
      </DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent
          className="min-w-[15rem] dark:border-input"
        >
          <DropdownMenuCheckboxItem
          checked={currentTheme === "yellow"}
          onCheckedChange={() => setTheme('yellow') }
            className={` px-4 py-4 flex gap-4 items-center cursor-pointer text-[1.6rem] text-sidebar-foreground  leading-[2rem] text-left `}
          >
            <Sun
              style={{
                width: 16,
                height: 16,
              }}
              className="text-foreground"
            />
            Light
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
          checked={currentTheme === "dark"}
          onCheckedChange={() => setTheme('dark') }
            className={` px-4 py-4 flex gap-4 items-center cursor-pointer text-[1.6rem] text-sidebar-foreground  leading-[2rem] text-left `}
          >
            <Moon
              style={{
                width: 16,
                height: 16,
              }}
              className="text-foreground"
            />
            Dark
          </DropdownMenuCheckboxItem>
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  );
}
